import axios from 'axios';

const baseURL = process.env.REACT_APP_API_BASE_URL || '/api';
const integrationsAdminToken = process.env.REACT_APP_INTEGRATIONS_ADMIN_TOKEN;

const instance = axios.create({
    baseURL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    }
});

if (integrationsAdminToken) {
    instance.defaults.headers.common['x-admin-token'] = integrationsAdminToken;
}

// Response interceptor
instance.interceptors.response.use(
    response => response,
    error => {
        if (error.response) {
            // Server tarafından hata döndü
            console.error('API Error:', error.response.data);
            return Promise.reject(error.response.data);
        } else if (error.request) {
            // İstek yapıldı ama cevap alınamadı
            console.error('Network Error:', error.request);
            return Promise.reject({ message: 'Ağ hatası. Lütfen internet bağlantınızı kontrol edin.' });
        } else {
            // İstek oluşturulurken hata oluştu
            console.error('Request Error:', error.message);
            return Promise.reject({ message: 'Bir hata oluştu. Lütfen daha sonra tekrar deneyin.' });
        }
    }
);

export default instance; 